export default __webpack_public_path__ + "static/media/29.4edf8b05.jpg";